module.exports = __webpack_public_path__ + "static/media/muchlis_rumalutur.9c38e9f0.jpg";